//import 'babel-polyfill'
// import '@babel/polyfill'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store/index'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '../public/css/main.css'
import VueBreadcrumbs from 'vue-breadcrumbs'
import DatetimePicker from 'vuetify-datetime-picker'
import vueHeadful from 'vue-headful';
import VueCookie from 'vue-cookies';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import '../public/fonts/fonts.css'
import VueGtag from 'vue-gtag'
import {checkIsProductionServer} from "@/helper";

Vue.use(VueCookie);
Vue.use(DatetimePicker)
Vue.use(Vuetify);

Vue.component(VueQrcode.name, VueQrcode);
Vue.component('vue-headful', vueHeadful);


Vue.use(VueBreadcrumbs, {
  template:
    `<nav class="breadcrumb" v-if="$breadcrumbs.length" xmlns="http://www.w3.org/1999/html">
    <template v-for="(crumb, i) in $breadcrumbs">
    <v-chip class="breadcrumb-item-chips"  color="blue lighten-3" disabled>
    <router-link class="breadcrumb-item":to="linkProp(crumb)" >{{ crumb | crumbText }}</router-link>
    </v-chip center>
    <span v-if="$breadcrumbs.length - 1 !== i"><v-icon small center>label_important</v-icon></span>
    </template>
    </nav>`
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

//HOOOOOOOOKKKK to xp chrome detected
function getChromeVersion () {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

    return raw ? parseInt(raw[2], 10) : false;
}
let chrome = getChromeVersion();
if(chrome && chrome <= 49){
  window.onload = function() {
    let element = document.getElementById('base-content');
    element.style.paddingTop = '60px';
    element =  document.getElementById("main-left-menu");
    element.style.marginTop = '60px';
    element.style.maxHeight = 'calc(100% - 60px)';
  }
}

